// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from "./icon.style";
interface IProps {
  style?: React.CSSProperties;
}
export const CalendarEditIcon: React.FC<IProps> = (props) => (
  <svg
    id="icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ ...iconStyle, ...props.style }}
  >
    <path d="M16 0c.55 0 1 .45 1 1v1h2c1.65 0 3 1.35 3 3v4.5l-2-2V5c0-.55-.45-1-1-1h-2v1c0 .55-.45 1-1 1s-1-.45-1-1V4H7v1c0 .55-.45 1-1 1s-1-.45-1-1V4H3c-.55 0-1 .45-1 1v3h14.5l-2 2H2v9c0 .55.45 1 1 1h2.5v2H3c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h2V1c0-.55.45-1 1-1s1 .45 1 1v1h8V1c0-.55.45-1 1-1Z" />
    <path d="M6 16c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1h1Zm0-4c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1h1Zm5.5 0c.266 0 .507.106.687.276l-1.748 1.72A1.002 1.002 0 0 1 9.5 13c0-.55.45-1 1-1h1ZM7 19.247v2.364c0 .218.171.389.389.389h2.364a.365.365 0 0 0 .272-.117l8.492-8.484-2.916-2.916-8.484 8.484a.382.382 0 0 0-.117.28Zm13.773-8.103a.774.774 0 0 0 0-1.097l-1.82-1.82a.775.775 0 0 0-1.097 0l-1.423 1.424 2.916 2.916 1.424-1.423Z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/CalendarEdit.tsx